module.exports = __webpack_public_path__ + "static/media/img-aboutUs02.66c09e19.66c09e19.jpg";